import {Injectable} from '@angular/core';
import {CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router';
import {Observable} from 'rxjs/Observable';
import {SessaoService} from './sessao.service';

@Injectable()
export class AuthguardGuard implements CanActivate {
	constructor(private sessaoService: SessaoService) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    if(sessionStorage.getItem("sessaoBF") && this.sessaoService.sessao.logado){
        return true;
    }
    return this.sessaoService.sessao.logado;
   }
}


// WEBPACK FOOTER //
// /home/runner/_work/fini-sta-01-estatico-sitecliente/fini-sta-01-estatico-sitecliente/src/app/services/authguard.guard.ts